import { gql } from '@apollo/client';

export const PARN_DETAILS_QUERY = gql`
  query ParnDetails($agentCustomerUuid: String!) {
    odProtosListingsServicesPartneragentreferralnetwork {
      getPARNDetails(input: { agentCustomerId: $agentCustomerUuid }) {
        parnDetails {
          parn {
            id
            sellDirectLeadToken
            state
            agentNote
            timestamps {
              key
              timestamp
            }
          }
          agentLead {
            id
            state
            proposalExpiration
          }
          listing {
            id
            state
            listingPrice
            contractPrice
            soldPrice
            grossCommission
            timestamps {
              state
              timestamp
            }
          }
          lead {
            id
            address {
              street
              city
              state
              postalCode
            }
            customerV2 {
              firstName
              lastName
              primaryPhoneNumber {
                number {
                  value
                }
                type
              }
              primaryEmail {
                address {
                  value
                }
              }
              otherEmails {
                address {
                  value
                }
              }
            }
          }
        }
      }
    }
  }
`;
